<template>
  <svg :width="width" :height="height" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.0541 16.8877V18.5353C11.0541 18.9903 11.4292 19.3591 11.8919 19.3591C12.3546 19.3591 12.7297 18.9903 12.7297 18.5353V16.8877C12.7297 16.4328 12.3546 16.064 11.8919 16.064C11.4292 16.064 11.0541 16.4328 11.0541 16.8877Z"
      :fill="color"
    />
    <path
      d="M11.0541 23.4781V21.8305C11.0541 21.3755 11.4292 21.0067 11.8919 21.0067C12.3546 21.0067 12.7297 21.3755 12.7297 21.8305V23.4781C12.7297 23.9331 12.3546 24.3019 11.8919 24.3019C11.4292 24.3019 11.0541 23.9331 11.0541 23.4781Z"
      :fill="color"
    />
    <path
      d="M11.0541 26.7733V28.4208C11.0541 28.8758 11.4292 29.2446 11.8919 29.2446C12.3546 29.2446 12.7297 28.8758 12.7297 28.4208V26.7733C12.7297 26.3183 12.3546 25.9495 11.8919 25.9495C11.4292 25.9495 11.0541 26.3183 11.0541 26.7733Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.7027 5.76655C7.7027 4.24642 9.63764 3.29517 11.8919 3.29517C14.1461 3.29517 16.0811 4.24642 16.0811 5.76655C16.0811 7.28668 14.1461 8.23793 11.8919 8.23793C9.63764 8.23793 7.7027 7.28668 7.7027 5.76655ZM13.887 5.33835C13.3854 5.09178 12.6687 4.94276 11.8919 4.94276C11.115 4.94276 10.3984 5.09178 9.89682 5.33835C9.52686 5.52023 9.37838 5.69282 9.37838 5.76655C9.37838 5.84028 9.52686 6.01287 9.89682 6.19474C10.3984 6.44132 11.115 6.59034 11.8919 6.59034C12.6687 6.59034 13.3854 6.44132 13.887 6.19474C14.2569 6.01287 14.4054 5.84028 14.4054 5.76655C14.4054 5.69282 14.2569 5.52023 13.887 5.33835Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1 5.76655C1 2.42655 5.93584 0 11.8919 0C12.1736 0 12.453 0.00542804 12.7297 0.016124V0H29.4865C30.8251 0 31.9193 1.02885 31.9957 2.32617L32 2.47138V24.7138C32 26.0299 30.9536 27.1058 29.6342 27.181L29.4865 27.1852H22.7838V28.3729L22.5101 28.618C19.9853 30.8789 16.5259 32 12.1723 32C7.97952 32 4.44993 30.9611 1.61124 28.876L1.32005 28.6566L1 28.4092V6.59034H1.10275C1.03503 6.32283 1 6.04793 1 5.76655ZM2.67568 8.89789V27.5995L2.89848 27.7592C5.29328 29.4219 8.24088 30.287 11.7633 30.3489L12.1723 30.3524C15.8703 30.3524 18.7792 29.4896 20.932 27.7794L21.1081 27.6341V8.89789C19.2902 10.4168 16.167 11.4036 12.6105 11.5212C12.6862 11.6451 12.7297 11.79 12.7297 11.945V13.5926C12.7297 14.0475 12.3546 14.4164 11.8919 14.4164C11.4292 14.4164 11.0541 14.0475 11.0541 13.5926V11.945C11.0541 11.79 11.0976 11.6451 11.1733 11.5212C7.61683 11.4036 4.49358 10.4168 2.67568 8.89789ZM22.681 6.59034H22.7838V25.5376H29.4865C29.9162 25.5376 30.2703 25.2196 30.3187 24.8099L30.3243 24.7138V2.47138C30.3243 2.04891 30.0009 1.70071 29.5842 1.65313L29.4865 1.64759H19.6037C21.5633 2.67066 22.7838 4.10567 22.7838 5.76655C22.7838 6.04793 22.7488 6.32283 22.681 6.59034ZM21.1081 5.76655C21.1081 3.64693 17.0412 1.64759 11.8919 1.64759C6.74255 1.64759 2.67568 3.64693 2.67568 5.76655C2.67568 7.88616 6.74255 9.88551 11.8919 9.88551C17.0412 9.88551 21.1081 7.88616 21.1081 5.76655Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'PottyIcon',
  props: {
    width: {
      type: Number,
      default: 32,
    },
    height: {
      type: Number,
      default: 32,
    },
    color: {
      type: String,
      default: '#4B4C52',
    },
  },
};
</script>
